import React, { useContext } from "react"
import LocaleContext from "../../context/LocaleContext"
import CalculatorsStyle from "./CalculatorsStyle.module.styl"
import CalculatorsInfoSection from "../calculatorsInfoSection/components/CalculatorsInfoSection"
import Image from "gatsby-image"
import translate from "../../translation/translator"
import keys from "../../translation/keys"

const CalculatorsPage = ({ images }) => {
  const locale = useContext(LocaleContext).locale
  console.log(keys.CALC_PAGE_U_ARE_NEW, locale)

  const calculatorImageOne = images[0].node.childImageSharp.fluid
  const calculatorImageTwo = images[1].node.childImageSharp.fluid
  const calculatorImageThree = images[3].node.childImageSharp.fluid
  const calculatorImageFour = images[4].node.childImageSharp.fluid
  const calculators = images[2].node.childImageSharp.fluid
  return (
    <div className={CalculatorsStyle.wrapper}>
      <Image fluid={calculators} className={CalculatorsStyle.header_image} />
      <p>{translate(keys.CALC_PAGE_WELCOME, locale)}</p>
      <p>{translate(keys.CALC_PAGE_U_ARE_NEW, locale)}</p>
      <p>{translate(keys.CALC_PAGE_U_ARE_OLD, locale)}</p>
      <p>{translate(keys.CALC_PAGE_WIGHT_PROBLEMS, locale)}</p>
      <p>{translate(keys.CALC_PAGE_U_WANT_BETTER_WEIGHT, locale)}</p>
      <p>{translate(keys.CALC_PAGE_CALCS, locale)}</p>
      <p>{translate(keys.CALC_PAGE_MAX_HELP, locale)}</p>
      <p>{translate(keys.CALC_PAGE_FIRST_CALC, locale)} </p>
      <Image
        fluid={calculatorImageThree}
        className={CalculatorsStyle.header_image}
      />
      <p>{translate(keys.CALC_PAGE_FIRST_CALC_TEXT, locale)}</p>
      <p>{translate(keys.CALC_PAGE_CAL_CALC, locale)}</p>
      <ul>
        <li>{translate(keys.CALC_PAGE_LOSE_KILOS, locale)}</li>
        <li>{translate(keys.CALC_PAGE_KEEP_KILOS, locale)}</li>
        <li>{translate(keys.CALC_PAGE_GAIN_KILOS, locale)}</li>
      </ul>
      <Image
        fluid={calculatorImageOne}
        className={CalculatorsStyle.header_image}
      />
      <p>{translate(keys.CALC_PAGE_CAL_CALC_TEXT, locale)}</p>
      <Image
        fluid={calculatorImageFour}
        className={CalculatorsStyle.header_image}
      />
      <p>{translate(keys.CALC_PAGE_TEXT_I, locale)}</p>
      <Image
        fluid={calculatorImageTwo}
        className={CalculatorsStyle.header_image}
      />
      <h4>{translate(keys.CALC_PAGE_HOW_TO_USE_CALCS, locale)}</h4>
      <p>{translate(keys.CALC_PAGE_CALCS_EXPLAIN, locale)} </p>
      <p>{translate(keys.CALC_PAGE_STEPS, locale)}</p>
      <div className="row mt-5 mb-4">
        <div className="col-lg-3 mb-3">
          <Image
            className={CalculatorsStyle.image}
            fluid={calculatorImageOne}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <Image
            className={CalculatorsStyle.image}
            fluid={calculatorImageTwo}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <Image
            className={CalculatorsStyle.image}
            fluid={calculatorImageThree}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <Image
            className={CalculatorsStyle.image}
            fluid={calculatorImageFour}
          />
        </div>
      </div>
      <ul>
        <li>{translate(keys.CALC_PAGE_STEP_INDEX, locale)}</li>
        <li>{translate(keys.CALC_PAGE_STEP_CAL, locale)}</li>
        <li>{translate(keys.CALC_PAGE_STEP_MACROS, locale)}</li>
        <li>{translate(keys.CALC_PAGE_TEXT_II, locale)}</li>
      </ul>
      <p>{translate(keys.CALC_PAGE_TEXT_III, locale)}</p>
      <p>{translate(keys.CALC_PAGE_TEXT_IV, locale)}</p>
      <p>{translate(keys.CALC_PAGE_TEXT_V, locale)}</p>
      <div className={CalculatorsStyle.info_holder}>
        <CalculatorsInfoSection />
      </div>
    </div>
  )
}

export default CalculatorsPage
